import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const entity = 'employee'
const entityMsg = 'employee'

let customActions = {}

const actions = {
	...crud('employee', 'el empleado', 'los empleados'),
	...customActions,
}

export const getEmployeeCatalogKey = (companyId, type) => `${companyId}:${type}`
let catalogRequestId = 0

// Keep catalog requests out of the shared employee list used by other screens.
const loadCatalog = (options = {}) => async (dispatch, getState) => {
	const state = getState()
	const catalogKey = getEmployeeCatalogKey(state.app.user.sys_company_id, options.params?.type)
	const requestId = ++catalogRequestId
	const meta = { catalogKey, requestId }
	dispatch({ type: 'FETCH_EMPLOYEE_CATALOG', meta, silent: options.silent })
	try {
		return await actions.load({ ...options, force: true })(action => {
			dispatch({ ...action, meta })
		}, getState)
	} finally {
		dispatch({ type: 'FINISH_EMPLOYEE_CATALOG', meta })
	}
}

const addFile = (emplooye_id, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/${emplooye_id}/upload_file`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: files,
			},
			successMessage: 'Se subió el archivo correctamente',
		})

		dispatch(actions.get(emplooye_id))
	}
}

const deleteFile = (emplooye_id, filename) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/${emplooye_id}/file/${filename}`, {
			method: 'DELETE',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: 'Se eliminó el archivo correctamente',
		})

		dispatch(actions.get(emplooye_id))
	}
}
const deleteImage = (emplooye_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/${emplooye_id.id}/image`, {
			method: 'DELETE',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: 'Se eliminó la imagen correctamente',
		})

		// dispatch(actions.get(emplooye_id))
	}
}
const deleteEmployee = (item) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/employee/${item.id}/delete_employee`, {
			method: 'DELETE',
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se eliminó el empleado correctamente.`,
		})
	}
}
const createEmployeeWithImage = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/create_employee_with_image`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: files,
				item: JSON.stringify(item),
			},

			successMessage: 'Se agrego el empleado correctamente.',
		})

		if (res.body?.error) {
			showErrorMessage({ error: res.body.error })
		} else {
			dispatch({
				type: 'ADD_EMPLOYEE',
				response: res.body,
			})
		}

		return res.body
	}
}

const updateEmployeeWithImage = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/employee/update_employee_with_image`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: files,
				item: JSON.stringify(item),
			},

			// successMessage: 'Se actualizó el empleado correctamente.',
		})

		showSuccessMessage('Se actualizó el empleado correctamente.')

		if (res.body?.error) {
			showErrorMessage({ error: res.body.error })
		} else {
			dispatch({
				type: 'UPDATE_EMPLOYEE',
				response: res.body,
			})
		}

		return res.body
	}
}

const addImage = (emplooye_id, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/${emplooye_id.id}/upload_image`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: files,
				item: JSON.stringify(emplooye_id),
			},
			successMessage: 'Se subió la imagen correctamente',
		})

		// dispatch(actions.get(emplooye_id))
	}
}

const updateEmployee = (employee_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/${employee_id.id}/update_add_file`, {
			method: 'PATCH',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: 'Se actualizó el empleado correctamente',
		})

		dispatch(actions.get(employee_id.id))
	}
}

const loadEmployeesUserCompany = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/load_employees_user_company`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options.params,
		})

		dispatch({
			type: `LOAD_EMPLOYEES`,
			response: res.body,
		})

		return res.body
	}
}

const loadWialonDrivers = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/drivers`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_WIALON_DRIVERS`,
			response: res.body,
		})

		return res.body
	}
}

const importFileCustom = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const currentPath = window.location.pathname

		let apiUrl = '/employee/import_data_from_excel?url=employees/employees'
		if (currentPath.includes('drivers')) {
			apiUrl = '/employee/import_data_from_excel?url=employees/drivers'
		}

		const res = await callApi(apiUrl, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: options.files,
			},
		})

		dispatch({
			type: 'IMPORT',
			payload: res.body,
		})

		return res.body
	}
}

const importEmployees = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/import_employees`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron los empleados correctamente.`,
		})
		showSuccessMessage('Se registraron los empleados correctamente')
		return res.body
	}
}

const loadDriversPermissions = (id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/drivers_permits/get_drivers_permissions/${id}`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)

		dispatch({
			type: `LOAD_DRIVERS_PERMISSIONS`,
			payload: res.body,
		})

		return res.body
	}
}

const loadEmployeesByUsertype = ({ userType }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/get_employees_by_usertype`, {
			method: 'GET',
			headers: {
				Authorization: state.app[userType].token,
			},
			params: {
				userType: userType,
				sys_company_id: state.app[userType].sys_company_id,
				[`${userType}_id`]: state.app[userType].id,
			},
		})

		dispatch({
			type: `LOAD_EMPLOYEES_BY_USERTYPE`,
			payload: res.body,
		})

		return res.body
	}
}

const getRequestsReport = (options) => {
	return async (dispatch, getState) => {
		const state = getState()
		
		try {
			const res = await callApi('/employee/utils/get_requests_report', {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
				params: options,
			})
			
			return res.body
		} catch (error) {
			console.error('Error fetching requests report:', error)
			return []
		}
	}
}

const getSidebarPinned = (employeeId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/${employeeId}/sidebar_pinned`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const updateSidebarPinned = (employeeId, sidebar_pinned) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/employee/${employeeId}/sidebar_pinned`, {
			method: 'PATCH',
			body: JSON.stringify({ sidebar_pinned }),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: 'Se actualizó el estado del menú lateral correctamente.',
		})

		dispatch({
			type: 'UPDATE_EMPLOYEE',
			response: res.body,
		})

		return res.body
	}
}

const getCustomEmployees = (params) => {
	return async (dispatch, getState) => {
		const state = getState()


		const res = await callApi(`/employee/custom_employees`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params,
		})

		return res.body
	}
}

export default {
	...actions,
	loadCatalog,
	addFile,
	deleteFile,
	addImage,
	deleteImage,
	updateEmployee,
	deleteEmployee,
	createEmployeeWithImage,
	updateEmployeeWithImage,
	loadEmployeesUserCompany,
	loadWialonDrivers,
	importEmployees,
	loadDriversPermissions,
	loadEmployeesByUsertype,
	importFileCustom,
	getRequestsReport,
	getSidebarPinned,
	updateSidebarPinned,
	getCustomEmployees
}
